"use client";
import {
  getInjectedConnector
} from "./chunk-MBBGZGXF.js";

// src/wallets/walletConnectors/injectedWallet/injectedWallet.ts
var injectedWallet = () => ({
  id: "injected",
  name: "Browser Wallet",
  iconUrl: async () => (await import("./injectedWallet-H7LYKTQS.js")).default,
  iconBackground: "#fff",
  createConnector: getInjectedConnector({})
});

export {
  injectedWallet
};
